angular.module('eStories.library', [

    /*Library Module*/
    'eStories.library.model',
    'eStories.account.model',
    'eStories.paging.model',
    'eStories.compnt.grid',
    'eStories.player.model'

])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.library', {
                url: 'library?pageNumber&sortField&tab&grid',
                views: {
                    'mainView@': {
                        templateUrl: 'library/library.tmpl.html',
                        controller: 'LibraryCtrl as libraryCtrl'
                    }
                }
            })
            .state('eStories.navbars.edit', {
                url: 'library/edit/:uploadedAudiobookId',
                views: {
                    'mainView@': {
                        templateUrl: 'library/edit/editAudiobookMetadata.tmpl.html',
                        controller: 'EditLibraryCtrl as editLibraryCtrl'
                    }
                }
            });
    }])

    .controller('LibraryCtrl', [
        'CatalogModel',
        'PagingModel',
        'LibraryModel',
        '$timeout',
        '$rootScope',
        '$scope',
        '$state',
        'PlayerModel',
        '$stateParams',
        'SortFilterFactory',
        '$location',
        'ReviewModel',
        'LL',
        'SeoModel',
        'ModalsModel',
        'GA',
        function (CatalogModel, PagingModel, LibraryModel, $timeout, $rootScope, $scope, $state, PlayerModel,
                  $stateParams, SortFilterFactory, $location, ReviewModel, LL, SeoModel, ModalsModel, GA) {

            SeoModel.applyMetaTags($state.current.name);

            const libraryCtrl = this;
            this.headerAudiobookList = [];
            this.tabList = [];
            this.selectedTabIndex = parseInt($stateParams.tab) || 0;
            this.selectedSortFieldIndex = parseInt($stateParams.sortField) || 0;
            this.showGridView = parseInt($stateParams.grid) === 1;
            this.moreMenuLibraryAudiobook = null;
            this.currentPagination = {pageNumber: parseInt($stateParams.pageNumber) || 1};
            this.sortFieldList = [
                {id: 'RECENTLY_PLAYED', name: 'Recently Played'},
                {id: 'DATE_ADDED', name: 'Date Added'},
                {id: 'RATING', name: 'Rating'},
                {id: 'TITLE', name: 'Title'},
                {id: 'REVIEW_DATE', name: 'Review Date'},
                {id: 'DURATION', name: 'Duration'}
            ];

            GA.trackPageView($location.path());
            // noinspection JSUnusedGlobalSymbols
            this.shouldShowGridView = () => {
                if ($rootScope.windowWidth <= 768) {
                    return true;
                }
                return !!this.showGridView;
            };

            // noinspection JSUnusedGlobalSymbols
            this.showMoreMenu = libraryAudiobook => {
                this.moreMenuLibraryAudiobook = libraryAudiobook;
            };

            // noinspection JSUnusedGlobalSymbols
            this.closeShowMoreMenu = () => {
                this.moreMenuLibraryAudiobook = null;
            };

            // noinspection JSUnusedGlobalSymbols
            this.shouldShowMoreMenu = libraryAudiobook => {
                return this.moreMenuLibraryAudiobook === libraryAudiobook;
            };

            libraryCtrl.isUploadedBook = (libraryAudiobook) => {
                return libraryAudiobook.audiobook['providerType'] !== "FINDAWAY";
            };

            libraryCtrl.shouldHidePlayButton = (libraryAudiobook) => {
                if (!libraryAudiobook) return;
                return PlayerModel.isPlaying && libraryAudiobook.id === PlayerModel.currentPlayingLibraryAudiobook.id;
            };

            libraryCtrl.getLibraryPage = async (pageNumber) => {
                const sortField = this.sortFieldList[this.selectedSortFieldIndex].id;
                const descending = sortField !== "TITLE";
                const itemsPerPage = 40;
                const pagination = PagingModel.preparePagination(pageNumber, itemsPerPage, descending, true, sortField);
                const status = this.selectedTabIndex === 1 ? 'STORED' : null;
                const response = await LibraryModel.getLibraryContent(pagination, status);

                if (response['responseStatus'] !== 'SUCCESS') {
                    return;
                }
                const totalCount = response.totalCount;

                libraryCtrl.getAllLibraryAudiobooksProgress(response['libraryAudiobookList'], () => {
                    if (libraryCtrl.libraryList && pageNumber > 1) {
                        libraryCtrl.libraryList = libraryCtrl.libraryList.concat(response['libraryAudiobookList']);
                    } else {
                        libraryCtrl.libraryList = response['libraryAudiobookList']; // Array of Audiobooks
                        LibraryModel.assignLibraryList(libraryCtrl.libraryList);
                    }
                    libraryCtrl.headerAudiobookList = libraryCtrl.libraryList.map(v => v.audiobook);
                });

                this.currentPagination = {pageNumber, itemsPerPage, totalCount};

                $timeout(() => {
                    $rootScope.$broadcast('setTotalCount', response.totalCount);
                    $rootScope.$broadcast('hasMoreBooksToLoad', response.totalCount > libraryCtrl.libraryList.length);

                }, 0);

                if (libraryCtrl.libraryList.length !== 0) {
                    return;
                }

                this.emptySection = {
                    id: 'BEST_SELLERS_' + LibraryModel.getSectionItemLocation(),
                    title: 'Best Sellers'
                };

                const getSectionItemListObj = {
                    sectionId: this.emptySection.id,
                    pagination: PagingModel.preparePagination(1, 12)
                };
                const section = await CatalogModel.getSectionItemList(getSectionItemListObj);
                this.emptySectionList = section.sectionItemList;
                safeApply($scope);

            };

            // noinspection JSUnusedGlobalSymbols
            this.hideDivsShowInputs = false;
            // noinspection JSUnusedGlobalSymbols
            this.showChapterEdit = false;
            // noinspection JSUnusedGlobalSymbols
            this.editingChapterNow = false;

            this.getFilterGenreList = async () => {
                const response = await CatalogModel.getFilterGenreList({});
                if (response != null && response['responseStatus'] === "SUCCESS") {
                    libraryCtrl.allGenreList = response['genreList'];
                }
            };

            this.getSubGenreList = async () => {
                const response = await CatalogModel.getSubGenreList({genreId: parseInt(this['chosenGenreId'])});
                if (response['responseStatus'] !== "SUCCESS") {
                    return;
                }
                this.subGenreList = response['genreList'];
            };

            libraryCtrl.parseAllLibraryForUploadedAudiobooks = (listOfLibraryObj) => {
                libraryCtrl.arrayOfUploadedAudiobooks =
                    listOfLibraryObj.filter(x => x.audiobook['providerType'] === "USER");
            };

            $scope.$on('playAudiobook', (event, audiobook) => {
                libraryCtrl.playingCover = audiobook.audiobook['coverUrl'];
            });

            libraryCtrl.audiobookAbridged = (abridged) => {
                return abridged ? 'Abridged' : 'Unabridged';
            };

            libraryCtrl.getAudiobookRuntime = (runtime) => {
                if (runtime == null) {
                    return;
                }
                return runtime.toString().toHHMMSS();
            };

            libraryCtrl.getFullDate = (streetDate) => {
                return getFullDate(streetDate);
            };

            libraryCtrl.getStringDate = (dateData) => {
                return getStringDate(dateData);
            };

            libraryCtrl.currentState = $state.current.name;


            libraryCtrl.addToWishList = async (audiobook) => {
                const response = await CatalogModel.addToWishList(audiobook);
                if (response != null && response['responseStatus'] === 'SUCCESS') {
                    libraryCtrl.item.wishListItemId = response.wishListItemId;
                }
            };

            libraryCtrl.deleteFromWishList = async (wishListItemId) => {
                const response = await CatalogModel.deleteFromWishList(wishListItemId);
                if (response != null && response['responseStatus'] === 'SUCCESS') {
                    libraryCtrl.item.wishListItemId = null;
                }
            };

            libraryCtrl.deleteLibraryAudiobook = async (libraryAudiobook) => {
                const confirmationModal = libraryCtrl.openDeleteBookConfirmationModal(libraryAudiobook.audiobook.title);

                confirmationModal.result.then(async (result) => {
                    if (!result.confirmed) {
                        return;
                    }

                    const response = await LibraryModel.deleteUploadedLibraryAudiobookFiles(libraryAudiobook.id);

                    if (response && response['responseStatus'] === 'SUCCESS') {
                        libraryCtrl.removeEntryFromLibrary(libraryAudiobook.id);
                    }
                });
            };

            libraryCtrl.removeEntryFromLibrary = (libraryAudiobookId) => {
                const libraryList = libraryCtrl.libraryList;
                for (let i = 0; i < libraryList.length; i++) {
                    if (libraryList[i].id === libraryAudiobookId) {
                        libraryList.splice(i, 1);
                        break;
                    }
                }
            };

            libraryCtrl.removeItemFromPageAndRefresh = async (index) => {
                let currentPagination = this.currentPagination;
                let page = currentPagination.pageNumber;
                if (libraryCtrl.libraryList.length === 1) {
                    // If it's the last page, reloading it will show an empty page so we'll the grab previous page.
                    if (page > 1 && page === Math.ceil(currentPagination.totalCount / currentPagination.itemsPerPage)) {
                        page--;
                    }
                    this.gotoPage(page);
                    return;
                } else {
                    libraryCtrl.libraryList.splice(index, 1);
                    currentPagination.totalCount--;
                }
                await this.refreshTopBarData();
                safeApply($scope);
            };

            libraryCtrl.archiveLibraryAudiobook = async (libraryAudiobook, index) => {
                const response = await LibraryModel.archiveLibraryAudiobook(libraryAudiobook.id);
                if (response['responseStatus'] !== 'SUCCESS') {
                    return;
                }

                await this.removeItemFromPageAndRefresh(index);
            };

            libraryCtrl.restoreLibraryAudiobook = async (libraryAudiobook, index) => {
                const response = await LibraryModel.restoreLibraryAudiobook(libraryAudiobook.id);
                if (response['responseStatus'] !== 'SUCCESS') {
                    return;
                }
                await this.removeItemFromPageAndRefresh(index);
            };

            libraryCtrl.markFinished = async (libraryAudiobook, finished = true) => {
                const response = await LibraryModel.markFinished(libraryAudiobook, finished);
                if (response['responseStatus'] !== 'SUCCESS') {
                    return;
                }

                if (finished) {
                    libraryAudiobook.precentProgress = 100;
                    libraryAudiobook.positionInBook = libraryAudiobook.totalRuntime;
                    libraryAudiobook.remainingTime = 0;
                    libraryAudiobook.completedDate = new Date().getTime();
                } else {
                    libraryAudiobook.precentProgress = 0;
                    libraryAudiobook.positionInBook = 0;
                    libraryAudiobook.remainingTime = libraryAudiobook.totalRuntime;
                    libraryAudiobook.completedDate = null;
                }
                PlayerModel.getAudiobookProgressBarPercent(libraryAudiobook);
                PlayerModel.getAudiobookRemainingTime(libraryAudiobook);
                safeApply($scope);
            };

            libraryCtrl.playLibraryAudiobook = (libraryAudiobook) => {
                $rootScope.$broadcast('playAudiobook', libraryAudiobook);
            };

            libraryCtrl.getAllLibraryAudiobooksProgress = (libraryList, callbackFunc) => {
                for (let i = 0; i < libraryList.length; i++) {
                    PlayerModel.setAudiobookProgress(libraryList[i]);
                }

                if (callbackFunc) {
                    callbackFunc();
                }
            };

            libraryCtrl.openBookmarksModal = (libraryAudiobook) => {
                if (libraryAudiobook.bookmarkList.length === 0) {
                    return;
                }

                LibraryModel.openBookmarksModal(libraryAudiobook);
            };
            // edit audiobook
            libraryCtrl.editAudiobook = () => {
                $location.path('library/edit');
            };

            libraryCtrl.downloadReport = () => {
                LL.tagEvent('Download to Device');
            };

            libraryCtrl.processingLibraryAudiobookIterations = 0;
            libraryCtrl.processingLibraryAudiobook = null;
            libraryCtrl.processingLibraryAudiobookInterval = null;

            libraryCtrl.isProcessingDownload = (libraryAudiobook) => {
                return libraryCtrl.processingLibraryAudiobook != null &&
                    libraryCtrl.processingLibraryAudiobook.id === libraryAudiobook.id;
            };

            libraryCtrl.startAudiobookDownload = (downloadUrl) => {
                window.location.href = downloadUrl;
            };

            libraryCtrl.downloadAudiobook = (libraryAudiobook) => {

                libraryCtrl.stopProcessingAudiobookDownload();
                // SEE EMUB-14305
                /*if (libraryAudiobook.downloadUrl != null) {
                    libraryCtrl.startAudiobookDownload(libraryAudiobook.downloadUrl);
                    return;
                }*/

                libraryCtrl.processAudiobookDownload(libraryAudiobook);
            };

            libraryCtrl.stopProcessingAudiobookDownload = () => {
                libraryCtrl.processingLibraryAudiobook = null;
                libraryCtrl.processingLibraryAudiobookIterations = 0;
                if (libraryCtrl.processingLibraryAudiobookInterval != null) {
                    clearInterval(libraryCtrl.processingLibraryAudiobookInterval);
                    libraryCtrl.processingLibraryAudiobookInterval = null;
                }
            };

            libraryCtrl.processAudiobookDownload = (libraryAudiobook) => {
                libraryCtrl.processingLibraryAudiobook = libraryAudiobook;
                libraryCtrl.processingLibraryAudiobookInterval = setInterval(async () => {
                    libraryCtrl.processingLibraryAudiobookIterations++;
                    if (libraryCtrl.processingLibraryAudiobookIterations === 80) {
                        libraryCtrl.stopProcessingAudiobookDownload();
                        console.log("Unable to prepare download. Tried 80 times.");
                        return;
                    }

                    const response = await LibraryModel.checkIfDownloadIsReady(libraryAudiobook.id);
                    if (response.responseText !== "SUCCESS") {
                        return;
                    }

                    libraryCtrl.stopProcessingAudiobookDownload();
                    libraryAudiobook.downloadUrl = response.downloadUrl;
                    libraryCtrl.startAudiobookDownload(response.downloadUrl)
                }, 5000);
            };

            libraryCtrl.editReview = (libraryAudiobook) => {
                ReviewModel.libraryAudiobookToRate = libraryAudiobook;
                ReviewModel.myRating = libraryAudiobook.review ? libraryAudiobook.review.rating * 2 : null;
                ReviewModel.openReviewModal();
            };

            libraryCtrl.deleteReview = async (libraryAudiobook) => {
                const response = await ReviewModel.deleteReview(libraryAudiobook.review.id);
                if (response['responseStatus'] === 'SUCCESS') {
                    libraryAudiobook.review = null;
                }
            };

            this.gotoPage = async (pageNumber) => {
                if (parseInt($stateParams.tab) === this.selectedTabIndex &&
                    parseInt($stateParams.pageNumber) === pageNumber &&
                    parseInt($stateParams.sortField) === this.selectedSortFieldIndex &&
                    (parseInt($stateParams.grid) === 1) === this.showGridView) {
                    this.libraryList = null;
                    await this.getLibraryPage(pageNumber);
                } else {
                    $location.search({
                        'tab': this.selectedTabIndex,
                        'pageNumber': pageNumber,
                        'sortField': this.selectedSortFieldIndex,
                        'grid': this.showGridView ? 1 : 0
                    });
                }
                safeApply($scope);
            };

            $scope.$on('getPage', (event, pageNumber) => {
                this.gotoPage(pageNumber);
            });

            $scope.$on('loadMore', (event, pageNumber) => {
                libraryCtrl.getLibraryPage(pageNumber).then();
            });

            $scope.$on("NOTIFICATION_AUDIOBOOK_PURCHASED", () => {
                $state.reload();
            });

            $scope.$on('uploadComplete', () => {
                if ($state.current.name === 'eStories.navbars.library') {
                    this.gotoPage(this.currentPagination.pageNumber);
                }
            });

            $scope.$on('tabSelected', (e, tab, index) => {
                this.selectedTabIndex = index;
                this.gotoPage(1);
            });

            $scope.$on('sortFieldSelected', (e, sortField, index) => {
                this.selectedSortFieldIndex = index;
                libraryCtrl.libraryList = null;
                this.gotoPage(1);
            });

            $scope.$on('gridListButtonClicked', (e, showGridView) => {
                this.showGridView = showGridView;
                safeApply($scope);
            });

            libraryCtrl.refreshTopBarData = async () => {
                const response = await LibraryModel.getLibraryCountMap();
                const countMap = response['countMap'];
                this.tabList = [
                    {id: 'ACTIVE', name: `Audiobooks (${countMap['ACTIVE']})`},
                    {id: 'STORED', name: `Archive (${countMap['STORED']})`}
                ];
            };

            libraryCtrl.getLibraryPage(this.currentPagination.pageNumber).then();

            /*Initial Call*/
            libraryCtrl.refreshTopBarData().then();

            libraryCtrl.openUploadModal = () => {
                LL.tagEvent("Upload Select");
                ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl')
            };

            libraryCtrl.openDeleteBookConfirmationModal = (title) => {
                return ModalsModel.open(
                    '/library/deleteAudiobookConfirmationModal/deleteAudiobookConfirmationModal.tmpl.html',
                    'DeleteBookConfirmationModalCtrl',
                    'deleteConfModalCtrl',
                    null,
                    {audioBookTitle: () => title});
            };
        }
    ])
    .controller('EditLibraryCtrl', [
        'CatalogModel',
        'PagingModel',
        'LibraryModel',
        '$timeout',
        '$rootScope',
        '$scope',
        '$state',
        'PlayerModel',
        '$controller',
        '$stateParams',
        'SortFilterFactory',
        '$location',
        function (CatalogModel, PagingModel, LibraryModel, $timeout, $rootScope, $scope, $state, PlayerModel,
                  $controller, $stateParams, SortFilterFactory, $location) {

            const editLibraryCtrl = this;

            // var libraryCtrl = $controller('LibraryCtrl', {$scope: $scope});
            // angular.extend(this, libraryCtrl);


//            ONLY run this when in the edit view - TODO: move this and the rest of edit metadata stuff / view to new ctrl

            /*Initial Calls for editing metadata*/

            editLibraryCtrl.getFilterGenreList = async () => {
                const response = await CatalogModel.getFilterGenreList({});
                if (response['responseStatus'] !== "SUCCESS") {
                    return;
                }
                editLibraryCtrl.allGenreList = response['genreList'];
            };

            editLibraryCtrl.getAllLibraryAudiobooksProgress = (libraryList, callbackFunc) => {
                for (let i = 0; i < libraryList.length; i++) {
                    PlayerModel.setAudiobookProgress(libraryList[i]);
                }

                if (callbackFunc) {
                    callbackFunc();
                }
            };

            editLibraryCtrl.getAllLibraryAudiobooks = async () => {
                const pagination = PagingModel.preparePagination(1, 1000, true, true, null);
                const response = await LibraryModel.getLibraryContent(pagination);
                if (response['responseStatus'] !== 'SUCCESS') {
                    return;
                }

                editLibraryCtrl.getAllLibraryAudiobooksProgress(response['libraryAudiobookList'], () => {
                    editLibraryCtrl.libraryList = response['libraryAudiobookList']; // Array of Audiobooks
                    editLibraryCtrl.parseAllLibraryForUploadedAudiobooks(editLibraryCtrl.libraryList);
                });
            };

            editLibraryCtrl.getAudiobookDetails = async (audiobookId) => {
                const response = await LibraryModel.getLibraryAudiobook(audiobookId);
                if (response != null && response['responseStatus'] === "SUCCESS") {
                    editLibraryCtrl.uploadedBookToEdit = response;
                }
            };


            editLibraryCtrl.parseAllLibraryForUploadedAudiobooks = (listOfLibraryObj) => {
                const result = [];
                for (let i = 0; i < listOfLibraryObj.length; i++) {
                    if (listOfLibraryObj[i].audiobook['providerType'] === "USER") {
                        result.push(listOfLibraryObj[i])
                    }
                }
                editLibraryCtrl.arrayOfUploadedAudiobooks = result;
            };

            if (LibraryModel.libraryList) {
                editLibraryCtrl.parseAllLibraryForUploadedAudiobooks(LibraryModel.libraryList);
            } else {
                editLibraryCtrl.getAllLibraryAudiobooks().then();
            }

            editLibraryCtrl.uploadedAudiobookId = $stateParams.uploadedAudiobookId;


            // libraryCtrl.getAllLibraryAudiobooks();

            //  checks to see if editing a book

            editLibraryCtrl.editingUploadedAudiobook = () => {
                //  if editing, get audiobook details information (catalog model)
                editLibraryCtrl.getAudiobookDetails(editLibraryCtrl.uploadedAudiobookId).then();
                if ($location.$$path.indexOf('edit') > 0) {
                    editLibraryCtrl.getFilterGenreList().then();
                }
            };

            editLibraryCtrl.editingUploadedAudiobook();

            //          edit book info metadata (audiobook title, authors, narrators, genre)

            editLibraryCtrl.changeLibraryAudiobookMetadata = async () => {
                const bookChangesObj = {};
                editLibraryCtrl.formatNarratorAuthorLists(editLibraryCtrl.uploadedBookToEdit.libraryAudiobook.audiobook.narratorList);
                bookChangesObj.narratorList = editLibraryCtrl.names;
                editLibraryCtrl.formatNarratorAuthorLists(editLibraryCtrl.uploadedBookToEdit.libraryAudiobook.audiobook.authorList);
                bookChangesObj.libraryAudiobookId = editLibraryCtrl.uploadedBookToEdit.libraryAudiobook.id;
                bookChangesObj.title = editLibraryCtrl.uploadedBookToEdit.libraryAudiobook.audiobook.title;
                bookChangesObj.genreId = editLibraryCtrl['chosenGenreId'];
                await LibraryModel.changeLibraryAudiobookMetadata(bookChangesObj);
                editLibraryCtrl.getAudiobookDetails(editLibraryCtrl.uploadedAudiobookId).then();
                $location.url('/library');
            };

//            edit chapter info

            editLibraryCtrl.changeLibraryAudiobookChapterMetadata = async (chapterId, index) => {
//              gets chapter that was edited
                editLibraryCtrl.editedChapter = editLibraryCtrl.uploadedBookToEdit.libraryAudiobook.audiobook['chapterList'][index];
//              renames the edited chapter .id to .chapterId (this is how the server wants it)
                editLibraryCtrl.editedChapter.chapterId = editLibraryCtrl.editedChapter.id;
                delete editLibraryCtrl.editedChapter.id;

                editLibraryCtrl.requestPending = true;

                const bookChangesObj = {};
                bookChangesObj.libraryAudiobookId = editLibraryCtrl.uploadedBookToEdit.libraryAudiobook.id;


//                get chapter change info
                bookChangesObj.chapterMetadataChangeList = [editLibraryCtrl.editedChapter];
                const iSPartANum = /^\d+$/.test(bookChangesObj.chapterMetadataChangeList[0]['partNumber']);
                const iSChapterANum = /^\d+$/.test(bookChangesObj.chapterMetadataChangeList[0].chapterNumber);
//                checks that chapter numbers and part numbers are only numerical characters
                if (!iSPartANum || !iSChapterANum) {
                    editLibraryCtrl.requestPending = false;
                    editLibraryCtrl.changeChapterError = "Chapter number and part must be numerical characters only";
                    editLibraryCtrl.getAudiobookDetails(editLibraryCtrl.uploadedAudiobookId).then();
                    return;
                }
//              removes error, if there is one
                editLibraryCtrl.changeChapterError = null;
                editLibraryCtrl.rowToEdit = null;
//                if user leaves book dropdown blank, fill with current audiobook id
                if (!editLibraryCtrl['newLibraryAudiobook']) {
                    bookChangesObj.chapterMetadataChangeList[0].newLibraryAudiobookId = editLibraryCtrl.uploadedBookToEdit.id;
                } else {
                    bookChangesObj.chapterMetadataChangeList[0].newLibraryAudiobookId = editLibraryCtrl['newLibraryAudiobook'].id;
                }

                const response = await LibraryModel.changeLibraryAudiobookMetadata(bookChangesObj);
                if (response['responseStatus'] === "SUCCESS") {
                    editLibraryCtrl.requestPending = false;
//                        refresh audiobook info
                    editLibraryCtrl.getAudiobookDetails(editLibraryCtrl.uploadedAudiobookId).then();
                } else {
                    editLibraryCtrl.requestPending = false;
                    editLibraryCtrl.changeChapterError = "Internal error - please try again"
                }
            };

            editLibraryCtrl.wasEditingAnotherRow = (rowIndex) => {
                if (editLibraryCtrl.rowToEdit == null) {
                    editLibraryCtrl.rowToEdit = rowIndex;
                } else {
                    editLibraryCtrl.getAudiobookDetails(editLibraryCtrl.uploadedAudiobookId).then();
                    editLibraryCtrl.rowToEdit = rowIndex;
                }
            };

            editLibraryCtrl.formatNarratorAuthorLists = (object) => {
                const names = [];
                const objArray = object;
                for (let i = 0; i < objArray.length; i++) {
                    if (objArray[i].name) {
                        names.push(objArray[i].name)
                    }
                }
                editLibraryCtrl.names = names;
            };
        }
    ])
    .controller('DeleteBookConfirmationModalCtrl', ['$uibModalInstance', 'audioBookTitle', function ($uibModalInstance, audioBookTitle) {
        this.audioBookTitle = audioBookTitle;

        this.closeConfirmationModal = () => {
            $uibModalInstance.close({confirmed: false});
        };

        this.deleteConfirmed = () => {
            $uibModalInstance.close({confirmed: true})
        };
    }]);


